<template>
    <div class="version2-left-block">
        <div class="version2-left-block-p">
          <TopBlock></TopBlock>
          <BottomBlock></BottomBlock>
        </div>
    </div>
</template>

<script>
import BottomBlock from './bottomBlock.vue'
import TopBlock from './topBlock.vue'
export default {
  data() {
    return {

    }
  },
  components: {
    BottomBlock,
    TopBlock
  }
}
</script>
